import { ExpiresIn } from '@app/core/enums';

export const defaultSeriesConfig: Partial<Highcharts.Options> = {
  credits: { enabled: false },
  title: { text: undefined },
  yAxis: { title: { text: undefined } },
  xAxis: null, // to be fiiled
  legend: {
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'middle',
  },
};

export const defaultPieConfig: Partial<Highcharts.Options> = {
  chart: {
    type: 'pie'
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b>: {point.percentage:.1f} %',
      }
    }
  },
  credits: { enabled: false },
  title: { text: undefined },
};


export const seriesColors = {
  [ExpiresIn.ONE_MONTH]: '#00E272',
  [ExpiresIn.NEVER]: '#DB504A',
  [ExpiresIn.SIX_MONTH]: '#2CAFFE',
  [ExpiresIn.ONE_YEAR]: '#FFD25A',
  [ExpiresIn.THREE_YEARS]: '#FE6A35',
  [ExpiresIn.NOW]: '#6B8ABC',
};

export const legendIndexes = {
  [ExpiresIn.NOW]: 0,
  [ExpiresIn.ONE_MONTH]: 1,
  [ExpiresIn.SIX_MONTH]: 2,
  [ExpiresIn.ONE_YEAR]: 3,
  [ExpiresIn.THREE_YEARS]: 4,
  [ExpiresIn.NEVER]: 5,
};

